import { render, staticRenderFns } from "./settlement-bill-view.vue?vue&type=template&id=3524fcf8&scoped=true&"
import script from "./settlement-bill-view.vue?vue&type=script&lang=ts&"
export * from "./settlement-bill-view.vue?vue&type=script&lang=ts&"
import style0 from "./settlement-bill-view.vue?vue&type=style&index=0&id=3524fcf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3524fcf8",
  null
  
)

export default component.exports